/**
 * THROWAWAY — dev-only kitchen-sink route (DESIGN_UPDATES ticket 13).
 * Gated on `import.meta.env.DEV`: in a prod build `beforeLoad` 404s before the
 * lazy chunk is ever requested, so the gallery never reaches users. Delete this
 * file (and `src/features/dev-kitchen-sink/`) when token verification closes.
 */
import { lazy, Suspense } from 'react'

import { createFileRoute, notFound } from '@tanstack/react-router'

import { Spinner } from '@/components/ui/spinner'
import { isDEV } from '@/lib/constants'

const KitchenSinkPage = lazy(() =>
	import('@/features/dev-kitchen-sink/components/page').then((m) => ({
		default: m.KitchenSinkPage,
	})),
)

export const Route = createFileRoute('/_dashboard/dev/kitchen-sink')({
	beforeLoad: () => {
		if (!isDEV) throw notFound()
	},

	head: () => ({
		meta: [{ title: 'Kitchen Sink (dev) | BitLyft AIR®' }],
	}),

	component: RouteComponent,
})

function RouteComponent() {
	return (
		<Suspense fallback={<Spinner className="m-8" />}>
			<KitchenSinkPage />
		</Suspense>
	)
}
